import React from 'react';
import { TEST_IDS } from '../constants/testIds';
import { useContactForm } from '../hooks/useContactForm';

// Field limits — must stay in sync with backend ContactCreate model.
const MAX_NAME_CHARS = 120;
const MAX_EMAIL_CHARS = 254;
const MAX_SUBJECT_CHARS = 200;
const MAX_MESSAGE_CHARS = 4000;

export default function Contact() {
  const { form, submitting, sent, error, handle, submit } = useContactForm();

  return (
    <section className="w-full flex flex-col items-center text-center fade-up">
      <div className="text-[10px] font-mono-r tracking-[0.5em] uppercase opacity-70">
        ::  Get In Touch  ::
      </div>
      <h1 className="font-display text-6xl md:text-8xl mt-4">CONTACT</h1>
      <p className="font-mono-r text-xs md:text-sm tracking-[0.25em] uppercase opacity-70 mt-3">
        Tracks · Bookings · Hellos
      </p>

      <div className="ascii-divider my-10">─  ─  ─  ─  ─</div>

      <form onSubmit={submit} className="w-full max-w-xl flex flex-col gap-4 text-left">
        <input
          data-testid={TEST_IDS.contactName}
          required
          maxLength={MAX_NAME_CHARS}
          placeholder="Your name"
          value={form.name}
          onChange={handle('name')}
        />
        <input
          data-testid={TEST_IDS.contactEmail}
          required
          type="email"
          maxLength={MAX_EMAIL_CHARS}
          placeholder="Your email"
          value={form.email}
          onChange={handle('email')}
        />
        <input
          data-testid={TEST_IDS.contactSubject}
          maxLength={MAX_SUBJECT_CHARS}
          placeholder="Subject (optional)"
          value={form.subject}
          onChange={handle('subject')}
        />
        <textarea
          data-testid={TEST_IDS.contactMessage}
          required
          rows={6}
          maxLength={MAX_MESSAGE_CHARS}
          placeholder="Your message"
          value={form.message}
          onChange={handle('message')}
        />

        <button
          data-testid={TEST_IDS.contactSubmit}
          type="submit"
          disabled={submitting}
          className="hairline px-8 py-4 font-mono-r text-xs tracking-[0.4em] uppercase bg-white text-black hover:bg-white hover:text-black transition-colors duration-300 disabled:opacity-50"
        >
          {submitting ? 'Transmitting…' : '→ Send Message'}
        </button>

        {sent && (
          <div
            data-testid={TEST_IDS.contactSuccess}
            className="hairline p-4 text-center font-mono-r text-xs tracking-[0.25em] uppercase mt-2"
          >
            ✓ Message received. We&apos;ll get back to you soon.
          </div>
        )}
        {error && (
          <div
            data-testid={TEST_IDS.contactError}
            className="hairline p-4 text-center font-mono-r text-xs tracking-[0.25em] uppercase mt-2"
          >
            ✗ {error}
          </div>
        )}
      </form>

      <div className="ascii-divider my-12">·  ·  ·  ·  ·</div>

      <div className="font-mono-r text-xs tracking-[0.25em] uppercase opacity-80">
        STUDIO ·  info@osolondon.com <br />
        BOOKINGS · info@osolondon.com
      </div>
    </section>
  );
}
